var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348.479,49.576h-.155l-28.517.143a66.176,66.176,0,0,1-63.024,46.1c-.308,0-.611,0-.92-.007a67.462,67.462,0,0,1-63.558-46.092l-28.63-.144h-.155a30,30,0,0,0-30,30V432.425a30.034,30.034,0,0,0,30,30h22.2A67.2,67.2,0,0,1,250.5,410.614c.285,0,.571-.006.855-.006,31.065,0,57.647,22,64.28,51.816h32.843a30.034,30.034,0,0,0,30-30V79.577a30,30,0,0,0-30-30ZM218,220.9h76a10,10,0,0,1,0,20H218a10,10,0,0,1,0-20Zm86,70H208a10,10,0,0,1,0-20h96a10,10,0,0,1,0,20Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.fc8afa552b165fbe93235ed9dfa8b8a9.svg";
export { ForwardRef as ReactComponent };